const CardBase = require("./card-base.js");

class CardYoutube extends CardBase {
    static type() {
        return "cardyoutube";
    }
}

module.exports = CardYoutube;